export var TemplateCategory;
(function (TemplateCategory) {
    TemplateCategory["JOB"] = "Job";
    TemplateCategory["SITE_ESTIMATE"] = "Site/Estimate";
    TemplateCategory["BUSINESS"] = "Business";
})(TemplateCategory || (TemplateCategory = {}));
